import { mdiImageMultiple } from '@lumapps/lumx/icons';

export const WIDGET_IMAGE_GALLERY_TYPE = 'image-gallery';

export const WIDGET_IMAGE_GALLERY_ICON = mdiImageMultiple;
export const WIDGET_IMAGE_GALLERY_EDITION_SCOPE = 'widget-image-gallery-edition';
